module.exports = __webpack_public_path__ + "img/2.d87e623a.png";